import { put, takeLatest, call } from 'redux-saga/effects';
import Homepage from '@interfaces/homepage';

import * as actions from './actions';
import * as types from './types';
import * as service from './service';

function* fetchHomepage() {
    try {
        const data: Homepage = yield call(service.fetchHomepage);

        yield put(actions.fetchHomepageSuccess(data));
    } catch (error) {
        yield put(actions.fetchHomepageError(error.message));
    }
}

export default function* appSaga() {
    yield takeLatest(types.FETCH_HOMEPAGE, fetchHomepage);
}
